import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProps } from '../../redux/actions';
import Loading from '../../componentes/Loading';
import LandingA from '../../componentes/LandingA';
import LandingB from '../../componentes/LandingB';
import LandingC from '../../componentes/LandingC';
import BarraLateral from '../../componentes/Barra-Lateral';
import ListaPropiedades from '../../componentes/ListaPropiedades';
import Paginacion from '../../componentes/Paginacion';
import SEO, { siteUrl } from '../../componentes/SEO';
//import CotizacionDolar from '../../componentes/CotizacionDolar';
import WhatsAppButton from '../../componentes/BotonWhastApp';
import './estilos.css';

function Home() {
  const loading = useSelector(state => state.loading);
  const [operacion, setOperacion] = useState('todas');
  const [tipoPropiedad, setTipoPropiedad] = useState('todos');
  const [precioMin, setPrecioMin] = useState('');
  const [precioMax, setPrecioMax] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const allProps = useSelector(state => state.propiedades);
  const totalPropiedades = useSelector(state => state.totPropiedades);
  const dispatch = useDispatch();
  const propiedadesPorPagina = 12;
  const limit = propiedadesPorPagina;
  const offset = (currentPage - 1) * limit;
  const businessJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'RealEstateAgent',
    name: 'Forastieri Propiedades',
    url: siteUrl,
    areaServed: 'Olavarria, Buenos Aires, Argentina',
    telephone: '+542281359060',
    sameAs: [
      'https://www.instagram.com/jf.negociosinmobiliarios/',
    ],
  };

  //efecto para iniciar la pagina desde la parte SUPERIOR
  useEffect(() => {
    // Desplaza la página hacia la parte superior cuando el componente se monta
    window.scrollTo(0, 0);
  }, []); // El array vacío asegura que se ejecute solo al montar el componente

  // Efecto para manejar la paginación y los filtros
  useEffect(() => {
    dispatch(getProps(limit, offset, operacion, tipoPropiedad, precioMin, precioMax));
  }, [dispatch, limit, offset, operacion, tipoPropiedad, precioMin, precioMax]);

  return (
    <div>
      <SEO
        title="Inmobiliaria en Olavarria"
        description="Forastieri Propiedades: casas, departamentos, terrenos y locales en venta y alquiler en Olavarria."
        path="/"
        jsonLd={businessJsonLd}
      />
      {loading ? (
        <Loading />
      ) : (
        <div className='home'>
          <LandingA />
          <LandingB />
          <LandingC />
          <div className='cont-barraLateral-Y-listaProps'>
          <h1 className='titulo-lista-props'>Conocé nuestras Propiedades</h1>
            {/* barra lat */}
            <div className='cont-barraLateral'>
              <BarraLateral
                muestraVentaAlq={'true'}
                soloAlq={'true'}
                setCurrentPage={setCurrentPage}
                setOperacion={setOperacion}
                setTipoPropiedad={setTipoPropiedad}
                precioMin={precioMin}
                setPrecioMin={setPrecioMin}
                precioMax={precioMax}
                setPrecioMax={setPrecioMax}
              />
            </div>
            {/* lista props y pag */}
            <div className='cont-listaProps-Y-paginacion'>
              <ListaPropiedades allProps={allProps} id='listaProps' />
              {
                allProps[0] && (
                  <Paginacion
                    allProps={allProps}
                    currentPage={currentPage}
                    onPageChange={setCurrentPage}
                    totalPropiedades={totalPropiedades}
                    propiedadesPorPagina={propiedadesPorPagina}
                  />
                )
              }
            </div>
          </div>
          
          {/* botón whatsapp */}
          <WhatsAppButton />
        </div>
      )}
    </div>
  );
}

export default Home;
